'use strict';

require('pixi');

require('p2');

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _LoadingState = require('./states/LoadingState');

var _LoadingState2 = _interopRequireDefault(_LoadingState);

var _PlayState = require('./states/PlayState');

var _PlayState2 = _interopRequireDefault(_PlayState);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.onload = function () {
  var game = new _phaser2.default.Game(_config2.default.gameWidth, _config2.default.gameHeight, _phaser2.default.AUTO, 'game');
  game.state.add('play', _PlayState2.default);
  game.state.add('loading', _LoadingState2.default);
  game.state.start('loading');
};

if (window.cordova) {
  var app = {
    initialize: function initialize() {
      document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
    },

    // deviceready Event Handler
    //
    onDeviceReady: function onDeviceReady() {
      this.receivedEvent('deviceready');

      // When the device is ready, start Phaser Boot state.
      window.game.state.start('Boot');
    },

    receivedEvent: function receivedEvent(id) {
      console.log('Received Event: ' + id);
    }
  };

  app.initialize();
}


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 331
// module chunks = 0